module.exports = "<div class=\"map-component\" id=\"{{ mapId }}\" [ngClass]=\"{edit: mode === 'add' || mode === 'edit'}\">\r\n  <div class=\"leaflet-top leaflet-left\">\r\n  </div>\r\n  <div class=\"leaflet-control-container\">\r\n    <div class=\"leaflet-bottom leaflet-left\">\r\n      <div class=\"leaflet-control-attribute leaflet-control thing-card-control\">\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/components/things/map/map.component.html
// module id = ../../../../../src/app/components/things/map/map.component.html
// module chunks = main